import { render, staticRenderFns } from "./EmployeeSettingsRole.vue?vue&type=template&id=7407659c&"
import script from "./EmployeeSettingsRole.vue?vue&type=script&lang=js&"
export * from "./EmployeeSettingsRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports